import React from 'react';
import {CMSLandingHorizontalRail} from '@tempo/landing';
import {Button} from '@tempo/core';
import Link from 'next/link';
import {StrapiOptimizedImage} from './StrapiOptimizedImage';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiHorizontalRailBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiHorizontalRailBlock: React.FC<
	StrapiHorizontalRailBlockProps
> = ({strapiBlockData, translationNamespace}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<CMSLandingHorizontalRail
			title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
			items={strapiBlockData.imageWithDesc.map((item: any) => ({
				image: (
					<StrapiOptimizedImage
						image={item.image}
						alt={resolve(item.alt)}
						sizes="300px"
					/>
				),
				description: resolve(item.description).replace(/<[^>]+>/g, ''),
				cta: (
					<Button as={Link} href={item.cta?.href ?? ''} variant="outline">
						{resolve(item.cta?.label)}
					</Button>
				),
			}))}
		/>
	);
};
